import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import { Dutch } from "flatpickr/dist/l10n/nl.js"

// Nederlandse datum-/tijdkiezer (24-uurs, week begint op maandag). Het veld
// verstuurt hetzelfde formaat als de native inputs (2026-10-02T14:30,
// 2026-10-02 of 14:30), maar toont "2 okt 2026 14:30".
const MODES = {
  datetime: { enableTime: true, dateFormat: "Y-m-d\\TH:i", altFormat: "j M Y, H:i", shortcut: "Nu" },
  date: { enableTime: false, dateFormat: "Y-m-d", altFormat: "j F Y", shortcut: "Vandaag" },
  time: { enableTime: true, noCalendar: true, dateFormat: "H:i", altFormat: "H:i", shortcut: "Nu" }
}

export default class extends Controller {
  static values = { mode: { type: String, default: "datetime" } }

  connect() {
    const { shortcut, ...mode } = MODES[this.modeValue] || MODES.datetime

    this.picker = flatpickr(this.element, {
      ...mode,
      locale: Dutch,
      time_24hr: true,
      minuteIncrement: 5,
      altInput: true,
      altInputClass: this.element.className,
      allowInput: true,
      disableMobile: true,
      onReady: (_dates, _str, instance) => this.addShortcut(instance, shortcut)
    })
  }

  disconnect() {
    this.picker?.destroy()
  }

  // Knop onder de kalender die direct de huidige datum/tijd invult.
  addShortcut(instance, label) {
    const button = document.createElement("button")
    button.type = "button"
    button.className = "gvz-datepicker-now"
    button.textContent = label
    button.addEventListener("click", () => {
      instance.setDate(new Date(), true)
      instance.close()
    })
    instance.calendarContainer.appendChild(button)
  }
}
